import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { TablePage } from "../../../containers";
import api from "../../../services/api";
import { displayDateTime } from "../../../utils/masks";
import toastOptions from "../../../utils/toastOptions";

interface PresencePerson {
  id?: number;
  name?: string;
  personName?: string;
  arrivedAt?: Date;
}

export default function PresencePersonList() {
  const { idPresence } = useParams<'idPresence'>();
  const location = useLocation();
  const navigate = useNavigate();
  const [pageNo, setPageNo] = useState<number>(1);
  const [termSearch, setTermSearch] = useState<string>("");
  const [delayedSearchTerm, setDelayedSearchTerm] = useState<string>("");
  const [refresh, setRefresh] = useState<boolean>(false);
  const presenceTitle = location.state?.presenceTitle as string | undefined;
  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    const delaySearch = setTimeout(() => {
      setDelayedSearchTerm(termSearch);
    }, 500);

    return () => clearTimeout(delaySearch);
  }, [termSearch]);

  useEffect(() => {
    setPageNo(1);
    setRefresh((current) => !current);
  }, [delayedSearchTerm]);

  const columns = [
    {
      name: "Nome",
      sortable: true,
      grow: 2,
      cell: (row: PresencePerson) => <span>{row.personName || row.name || "-"}</span>
    },
    {
      name: "Chegada em",
      sortable: true,
      cell: (row: PresencePerson) => (
        <span className="uk-text-xsmall uk-text-italic">
          {displayDateTime(row.arrivedAt) || "-"}
        </span>
      )
    }
  ];

  const fetchPresencePeople = async (page: number, limit: number) => {
    try {
      const response = await api.get(`/events/presence/${idPresence}/people`, {
        params: {
          page: page,
          limit: limit,
          name: delayedSearchTerm ? delayedSearchTerm.toUpperCase() : undefined
        }
      });

      setPageNo(page);
      setTotal(response.data.total);

      return response;
    } catch (e: any) {
      e.messages?.forEach((m: string) => {
        toast.error(m, toastOptions);
      });

      setTotal(0);
      return {
        data: { data: [], total: 0 }
      };
    }
  };

  return (
    <div id="page-presence-person-list" className="uk-margin-top">
      <TablePage
        title={presenceTitle ? `Lista ${presenceTitle}` : "Lista de Presença"}
        subTitle={"Pessoas registradas nesta lista de presença"}
        messageEmpty={<span>Nenhuma <b>pessoa</b> encontrada para esta lista.</span>}
        fetch={fetchPresencePeople}
        columns={columns}
        pageNo={pageNo}
        refresh={refresh}
        showSubHeader
        totalRecords={total}
        labelTotalRecords={`${total} ${total === 1 ? "Pessoa" : "Pessoas"}`}
        options={
          <div className="uk-grid-small uk-margin-top" uk-grid="true">
            <div className="uk-search uk-search-default uk-width-1-3@s">
              <span className="uk-search-icon-flip" uk-search-icon="true"></span>
              <input
                className="uk-search-input uk-input uk-form-small uk-text-uppercase"
                type="search"
                placeholder="Pesquise por nome..."
                value={termSearch}
                onChange={(ev) => {
                  setTermSearch(ev.target.value);
                }}
              />
            </div>
          </div>
        }
        backButtonAction={() => navigate(-1)}
      />
    </div>
  );
}
